<template>
  <div class="loading-indicator-container">
    <h4>ระบบกำลังนำคุณเข้าสู่ ALTV CMS</h4>
    <i class="fa fa-circle-notch fa-spin icon" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  created() {
    this.checkCurrentUser();
  },
  computed: {
    ...mapGetters(['currentUser', 'checkingTokenState']),
    teamName() {
      return this.$route.params.teamName;
    },
  },
  methods: {
    setAuthTokenInformation() {
      const { authToken, redirectUrl } = this.$route.query;
      const payload = {
        authToken,
        redirectUrl,
      };
      this.$store.dispatch('setAuthTokenInformation', payload);
    },
    async checkCurrentUser() {
      await this.$store.dispatch('loadCurrentUser');
      // If has logged in user, navigate to home page.
      if (this.currentUser) {
        this.$router.push('/');
        return;
      }
      this.setAuthTokenInformation();
      await this.$store.dispatch('checkAuthTokenPermission', this.teamName);
      if (this.checkingTokenState.status === 'success') {
        this.$router.push('/');
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-indicator-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    font-size: 72px;
    margin-top: $spacer * 2;
  }
}

</style>
